
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8"}},[_c('path',{attrs:{"d":"M39.453 34.61l-7.812-7.813c-.391-.313-.86-.547-1.328-.547h-1.25c2.109-2.734 3.437-6.172 3.437-10C32.5 7.344 25.156 0 16.25 0 7.266 0 0 7.344 0 16.25 0 25.234 7.266 32.5 16.25 32.5c3.75 0 7.188-1.25 10-3.438v1.329c0 .468.156.937.547 1.328l7.734 7.734c.782.781 1.953.781 2.657 0l2.187-2.187c.781-.703.781-1.875.078-2.657zM16.25 26.25a9.97 9.97 0 01-10-10c0-5.469 4.453-10 10-10 5.469 0 10 4.531 10 10 0 5.547-4.531 10-10 10z","fill":"#fff"}}),_c('path',{attrs:{"d":"M39.453 34.61l-7.812-7.813c-.391-.313-.86-.547-1.328-.547h-1.25c2.109-2.734 3.437-6.172 3.437-10C32.5 7.344 25.156 0 16.25 0 7.266 0 0 7.344 0 16.25 0 25.234 7.266 32.5 16.25 32.5c3.75 0 7.188-1.25 10-3.438v1.329c0 .468.156.937.547 1.328l7.734 7.734c.782.781 1.953.781 2.657 0l2.187-2.187c.781-.703.781-1.875.078-2.657zM16.25 26.25a9.97 9.97 0 01-10-10c0-5.469 4.453-10 10-10 5.469 0 10 4.531 10 10 0 5.547-4.531 10-10 10z","fill":"url(#paint0_linear)"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"-1","y1":"19.5","x2":"41","y2":"19.5","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#F0AD4F"}})])])])
          )
        }
      }
    